import { Box } from '@mentimeter/ragnar-ui/box';
import type { QuickFormStaticContent } from '@core-api/presentation/types/response';
import { usePresentationSlideContext } from '../../legacy-context/presentationContext';
import { TitleSection } from '../../shared/components/title-section/TitleSection';

export function MetadataPresentation() {
  const slide = usePresentationSlideContext();
  const staticContent = slide.staticContent as QuickFormStaticContent;

  return (
    <Box
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
      data-testid="metadata-container"
      p={4}
    >
      <TitleSection
        title={slide.title}
        styledTitle={staticContent.styledTitle as Record<string, unknown>}
        label={staticContent.label}
        fontSizeOffset={staticContent.textSizeOffset}
        textAlign="center"
        alignItems="center"
        mb="space4"
        showTextSizeDropdown={true}
      />
    </Box>
  );
}
